<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed border-end custom-sidebar team-sidebar-shell"
  id="sidebar1"
  [visible]="sidebarVisible"
  [unfoldable]="false"
  [narrow]="sidebarUnfoldable"
  (visibleChange)="onVisibleChange($event)"
>
  <div class="team-sidebar-shell__inner d-flex flex-column h-100 min-h-0 w-100">
  <div
    class="team-sidebar-brand"
    [class.team-sidebar-brand--collapsed]="sidebarUnfoldable"
    [class.px-3]="!sidebarUnfoldable"
  >
    <a
      routerLink="/"
      class="team-sidebar-brand__link text-decoration-none d-flex align-items-center gap-2 min-w-0"
      [class.justify-content-center]="sidebarUnfoldable"
      [attr.aria-label]="'sidebar.home' | translate"
    >
      <img
        src="assets/imalogo.png"
        alt=""
        class="team-sidebar-brand__logo flex-shrink-0"
        width="28"
        height="28"
      />
      <span *ngIf="!sidebarUnfoldable" class="team-sidebar-brand__text fw-bold mb-0">IMA One</span>
    </a>
  </div>

  <div class="px-3 pt-2 mb-3 d-flex flex-column gap-2 team-sidebar-actions">
    <a
      *ngIf="!sidebarUnfoldable"
      class="team-nav-session--new team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start overflow-hidden text-nowrap custom-action-btn hover-effect team-sidebar-action"
      [class.w-100]="!sidebarUnfoldable"
      [ngClass]="{'px-3 rounded-pill': !sidebarUnfoldable}"
      [class.team-sidebar-action--ghost]="!isNewDialogActive()"
      [class.team-nav-row-active]="isNewDialogActive()"
      [routerLink]="['/home']"
      [queryParams]="{ new: '1', scope: 'team', team_code: team_code }"
    >
      <span class="team-nav-session__inner min-w-0 w-100">
        <svg cIcon name="cilPlus" class="team-nav-session__icon" size="lg"></svg>
        <span class="team-nav-session__text">{{ 'sidebar.new_chat' | translate }}</span>
      </span>
    </a>
    <a
      *ngIf="sidebarUnfoldable"
      class="team-nav-icon-collapsed align-self-center"
      [class.is-active]="isNewDialogActive()"
      [routerLink]="['/home']"
      [queryParams]="{ new: '1', scope: 'team', team_code: team_code }"
      [attr.title]="'sidebar.new_chat' | translate"
      [attr.aria-label]="'sidebar.new_chat' | translate"
    >
      <svg cIcon name="cilPlus" size="lg"></svg>
    </a>
    <button
      type="button"
      class="team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start overflow-hidden text-nowrap custom-action-btn hover-effect team-sidebar-action team-sidebar-action--ghost team-sidebar-action--apps ima-unread-anchor"
      [class.w-100]="!sidebarUnfoldable"
      [ngClass]="{'justify-content-center px-0 rounded-circle w-auto align-self-center': sidebarUnfoldable, 'px-3 rounded-pill': !sidebarUnfoldable}"
      (click)="openAppModal()"
      [attr.title]="'sidebar.groups_apps' | translate"
      [attr.aria-label]="'sidebar.groups_apps' | translate"
    >
      <span class="team-nav-session__inner min-w-0 w-100" [class.justify-content-center]="sidebarUnfoldable">
        <svg cIcon name="cilApps" class="team-nav-session__icon" size="lg"></svg>
        <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text fade-in">{{ 'sidebar.groups_apps' | translate }}</span>
      </span>
      <span class="ima-unread-dot" *ngIf="hasChatroomUnread" [attr.aria-label]="'layout.chat.unreadPlaceChat' | translate"></span>
    </button>
  </div>

  <ng-scrollbar
    #scrollbar="ngScrollbar"
    class="overflow team-sidebar-scroll flex-grow-1 min-h-0 pb-2"
    pointerEventsMethod="scrollbar"
    visibility="native"
  >
    <div class="px-3 w-100 min-w-0">
    <nav
      *ngIf="favoriteApps.length > 0"
      class="team-imaginus-nav mb-3"
      [class.team-imaginus-nav--collapsed]="sidebarUnfoldable"
      [attr.aria-label]="'layout.chat.favoritesAria' | translate"
    >
      <div class="team-nav-label" *ngIf="!sidebarUnfoldable">{{ 'sidebar.favorites' | translate }}</div>
      <ng-container *ngIf="!sidebarUnfoldable">
        <a
          *ngFor="let fav of favoriteApps"
          class="team-nav-pill team-nav-fav-link text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start custom-action-btn hover-effect team-sidebar-action w-100"
          [ngClass]="{'px-3 rounded-pill': true}"
          [class.team-sidebar-action--ghost]="!isFavoriteLinkActive(fav)"
          [class.team-nav-row-active]="isFavoriteLinkActive(fav)"
          (click)="navigateFavoriteLink(fav)"
          [attr.title]="favoriteLinkTitle(fav)"
        >
          <span class="team-nav-session__inner w-100 min-w-0">
            <span class="fav-scope-avatar" aria-hidden="true">
              <img
                class="fav-scope-avatar__photo"
                [src]="favoriteScopeAvatarUrl(fav)"
                (error)="onFavoriteScopeAvatarError($event, fav)"
                alt=""
              />
              <span class="fav-scope-avatar__badge">
                <svg cIcon [name]="fav.icon || 'cilApps'" size="sm"></svg>
              </span>
            </span>
            <span class="team-nav-session__text-stack min-w-0">
              <span class="team-nav-session__text text-truncate d-block">{{ fav.label }}</span>
              <span *ngIf="favoriteScopeLabel(fav) as scopeLabel" class="fav-scope-tag text-truncate d-block">{{ scopeLabel }}</span>
            </span>
            <button
              type="button"
              class="team-nav-fav-unpin"
              (click)="onUnpinFavoriteClick($event, fav)"
              [attr.aria-label]="'layout.chat.unpinFavorite' | translate : { label: fav.label }"
              [title]="'layout.chat.unpinHint' | translate"
            >
              <svg class="team-nav-fav-unpin__icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 3.1l2.86 5.79 6.39.93-4.62 4.5 1.09 6.37L12 17.69l-5.72 3 1.09-6.37L2.75 9.82l6.39-.93L12 3.1z"
                      fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"/>
              </svg>
            </button>
          </span>
        </a>
      </ng-container>
      <ng-container *ngIf="sidebarUnfoldable">
        <a
          *ngFor="let fav of favoriteApps"
          class="team-nav-icon-collapsed"
          [class.team-nav-row-active]="isFavoriteLinkActive(fav)"
          (click)="navigateFavoriteLink(fav)"
          (contextmenu)="onUnpinFavoriteClick($event, fav)"
          [attr.title]="favoriteLinkTitle(fav) + ('layout.chat.unpinContext' | translate)"
          [attr.aria-label]="favoriteLinkTitle(fav)"
        >
          <span class="fav-scope-avatar fav-scope-avatar--collapsed" aria-hidden="true">
            <img
              class="fav-scope-avatar__photo"
              [src]="favoriteScopeAvatarUrl(fav)"
              (error)="onFavoriteScopeAvatarError($event, fav)"
              alt=""
            />
            <span class="fav-scope-avatar__badge">
              <svg cIcon [name]="fav.icon || 'cilApps'" size="sm"></svg>
            </span>
          </span>
        </a>
      </ng-container>
    </nav>

    <nav
      *ngIf="isChatMode"
      class="team-imaginus-nav team-chat-nav"
      [class.team-imaginus-nav--collapsed]="sidebarUnfoldable"
      [attr.aria-label]="'layout.chat.listAria' | translate"
    >
      <div class="team-chat-nav__head" *ngIf="!sidebarUnfoldable">
        <a
          class="team-chat-nav__back"
          routerLink="/home"
          [queryParams]="{ new: '1', scope: 'team', team_code: team_code }"
          [attr.title]="'layout.chat.backToImaginus' | translate"
        >
          <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span>{{ 'layout.chat.backToImaginus' | translate }}</span>
        </a>
        <span class="team-chat-nav__title">{{ 'layout.chat.title' | translate }}</span>
      </div>
      <a
        class="team-nav-session--new team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start overflow-hidden text-nowrap custom-action-btn hover-effect team-sidebar-action"
        [class.w-100]="!sidebarUnfoldable"
        [ngClass]="{'px-3 rounded-pill': !sidebarUnfoldable, 'justify-content-center px-0 rounded-circle w-auto': sidebarUnfoldable}"
        routerLink="/team/{{ team_code }}/chats"
        [queryParams]="{ new: 'dm' }"
        [attr.title]="'layout.chat.startDm' | translate"
      >
        <span class="team-nav-session__inner min-w-0 w-100" [class.justify-content-center]="sidebarUnfoldable">
          <svg cIcon name="cilPlus" class="team-nav-session__icon" size="lg"></svg>
          <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text">{{ 'layout.chat.startDm' | translate }}</span>
        </span>
      </a>
      <div class="team-nav-label" *ngIf="!sidebarUnfoldable && chatConversations.length > 0">{{ 'layout.chat.title' | translate }}</div>
      <a
        *ngFor="let conv of chatConversations; trackBy: trackByConversationKey"
        class="team-nav-pill text-decoration-none border-0 btn btn-transparent d-flex align-items-center text-start custom-action-btn hover-effect team-sidebar-action min-w-0 ima-unread-anchor"
        [class.w-100]="!sidebarUnfoldable"
        [ngClass]="{'justify-content-center px-0 rounded-circle w-auto': sidebarUnfoldable, 'px-3 rounded-pill': !sidebarUnfoldable}"
        [class.team-sidebar-action--ghost]="!isChatConversationActive(conv)"
        [class.team-nav-row-active]="isChatConversationActive(conv)"
        routerLink="/team/{{ team_code }}/chats/{{ conv.conversation_key }}"
        [attr.title]="conv.name"
      >
        <span class="team-nav-session__inner w-100 min-w-0">
          <svg
            cIcon
            [name]="conv.type === 'dm' ? 'cilUser' : 'cilChatBubble'"
            class="team-nav-session__icon"
            size="lg"
          ></svg>
          <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text text-truncate">{{ conv.name }}</span>
        </span>
        <span class="ima-unread-dot" *ngIf="isChatConversationUnread(conv)" [attr.aria-label]="'layout.chat.unreadMessage' | translate"></span>
      </a>
      <div class="team-chat-nav__empty" *ngIf="!sidebarUnfoldable && chatConversations.length === 0">
        {{ 'layout.chat.noChatrooms' | translate }}
      </div>
    </nav>

    <nav
      *ngIf="!isChatMode"
      class="team-imaginus-nav"
      [class.team-imaginus-nav--collapsed]="sidebarUnfoldable"
      [attr.aria-label]="'layout.chat.historyAria' | translate"
    >
      <div class="team-nav-label" *ngIf="!sidebarUnfoldable && displayImaginusList.length > 0">{{ 'layout.chat.recent' | translate }}</div>
      <div
        *ngFor="let s of displayImaginusList"
        class="team-nav-session team-nav-session--row w-100"
        [class.team-nav-session--has-menu]="showSessionMenuDropdown"
        [class.is-pinned]="teamImaginusNav.isPinned(team_code, s.id)"
        (touchstart)="onSessionRowTouchStart(s, $event)"
        (touchend)="onSessionRowTouchEnd($event)"
        (touchmove)="onSessionRowTouchMove($event)"
        (touchcancel)="onSessionRowTouchEnd($event)"
      >
        <a
          class="team-nav-pill text-decoration-none border-0 team-nav-session__link btn btn-transparent d-flex align-items-center text-start custom-action-btn hover-effect team-sidebar-action min-w-0"
          [class.w-100]="!sidebarUnfoldable"
          [ngClass]="{'justify-content-center px-0 rounded-circle w-auto': sidebarUnfoldable, 'px-3 rounded-pill': !sidebarUnfoldable}"
          [class.team-sidebar-action--ghost]="!isSessionQueryActive(s.id)"
          [class.team-nav-row-active]="isSessionQueryActive(s.id)"
          routerLink="/home"
          [queryParams]="{ session: s.id, scope: 'team', team_code: team_code }"
          [attr.title]="sessionLabel(s.name)"
          (click)="onSessionLinkClick($event, s)"
        >
          <span class="team-nav-session__inner w-100 min-w-0">
            <svg
              cIcon
              [name]="teamImaginusNav.isPinned(team_code, s.id) ? 'cilPin' : 'cilChatBubble'"
              class="team-nav-session__icon"
              size="lg"
            ></svg>
            <span *ngIf="!sidebarUnfoldable" class="team-nav-session__text text-truncate">{{ sessionLabel(s.name) }}</span>
          </span>
        </a>
        <div class="team-nav-session__tail" *ngIf="showSessionMenuDropdown">
          <c-dropdown
            [popperOptions]="sessionMenuPopperOptions"
            class="team-nav-dropdown"
          >
            <button
              type="button"
              cDropdownToggle
              class="team-nav-session__kebab"
              [attr.aria-label]="('layout.chat.menuPrefix' | translate) + ': ' + sessionLabel(s.name)"
            >
              <svg cIcon name="cilOptions" size="sm"></svg>
            </button>
            <ul cDropdownMenu class="team-nav-dropdown__menu">
              <li>
                <button
                  type="button"
                  cDropdownItem
                  class="team-nav-dropdown__item d-flex align-items-center gap-2 w-100 text-start"
                  (click)="onSessionMenuPin(s, $event)"
                >
                  <svg cIcon name="cilPin" class="team-nav-item-icon flex-shrink-0" size="sm"></svg>
                  <span>{{ (teamImaginusNav.isPinned(team_code, s.id) ? 'layout.chat.unpin' : 'layout.chat.pin') | translate }}</span>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  cDropdownItem
                  class="team-nav-dropdown__item d-flex align-items-center gap-2 w-100 text-start"
                  (click)="onSessionMenuRename(s, $event)"
                >
                  <svg cIcon name="cilPencil" class="team-nav-item-icon flex-shrink-0" size="sm"></svg>
                  <span>{{ 'layout.chat.rename' | translate }}</span>
                </button>
              </li>
              <li><hr class="dropdown-divider my-1" /></li>
              <li>
                <button
                  type="button"
                  cDropdownItem
                  class="team-nav-dropdown__item d-flex align-items-center gap-2 w-100 text-start text-danger"
                  (click)="onSessionMenuDelete(s, $event)"
                >
                  <svg cIcon name="cilTrash" class="flex-shrink-0" size="sm"></svg>
                  <span>{{ 'layout.chat.delete' | translate }}</span>
                </button>
              </li>
            </ul>
          </c-dropdown>
        </div>
      </div>
    </nav>
    </div>
  </ng-scrollbar>

  <div *ngIf="!sidebarUnfoldable" class="team-sidebar-footer px-3">
    <div class="team-sidebar-footer__search imaginus-sidebar-search-wrap w-100">
      <app-imaginus-session-search
        placement="footer"
        [teamCode]="team_code || null"
      ></app-imaginus-session-search>
    </div>
  </div>
  </div>

</c-sidebar>

<div
  class="wrapper d-flex flex-column min-vh-100"
  [class.wrapper--sidebar-overlay-open]="sidebarVisible && isMobile"
>
  <div
    class="custom-mask"
    *ngIf="sidebarVisible && isMobile"
    (click)="hideSidebar()"
    aria-hidden="true"
  ></div>

  <app-team-header [cShadowOnScroll]="'sm'" class="mb-4 d-print-none header header-sticky p-0 bg-transparent border-0" position="sticky" sidebarId="sidebar1" />

  <div class="body flex-grow-1">
    <c-container breakpoint="lg" class="h-auto px-2 px-sm-3 px-md-4">
      <router-outlet />
    </c-container>
  </div>
</div>

<c-modal [visible]="appModalVisible" size="xl" alignment="center" (visibleChange)="onAppModalVisibleChange($event)">
  <c-modal-header class="border-0">
    <h4 class="modal-title fw-bold">{{ 'layout.launcher.energyAppsTitle' | translate }}</h4>
    <button cButtonClose (click)="appModalVisible = false"></button>
  </c-modal-header>

  <c-modal-body class="p-4 team-app-modal-body">
    <p *ngIf="teamAppsLoading" class="text-muted text-center py-4 mb-0">{{ 'layout.launcher.loadingTeamApps' | translate }}</p>
    <p *ngIf="!teamAppsLoading && modalAppList.length === 0" class="text-muted text-center py-4 mb-0">{{ 'layout.launcher.noTeamApps' | translate }}</p>
    <c-row class="g-4" *ngIf="!teamAppsLoading && modalAppList.length > 0">
      <c-col *ngFor="let app of modalAppList" [xs]="12" [md]="6" [lg]="6">
        <c-card class="h-100 border-0 shadow-sm app-card">
          <c-card-body class="d-flex flex-column p-4">

            <div class="d-flex align-items-center mb-3">
              <div class="icon-wrapper rounded-circle me-3 d-flex align-items-center justify-content-center text-primary team-app-modal-icon-wrap">
                 <svg cIcon [name]="app.icon" size="lg"></svg>
              </div>
              <div>
                <h5 class="fw-bold mb-0">{{ app.name }}</h5>
                <small class="text-muted">{{ app.description }}</small>
              </div>
            </div>

            <hr class="my-2 opacity-25">

            <div class="d-flex flex-wrap gap-2 mt-2">
              <ng-container *ngFor="let child of app.children">
                <div class="d-inline-flex align-items-center gap-1">
                  <button
                    cButton
                    color="light"
                    variant="ghost"
                    class="btn-sm border fw-semibold d-flex align-items-center app-modal-nav-chip ima-unread-anchor"
                    (click)="navigateToLink(child.url);"
                  >
                    <span class="bullet-dot bg-primary me-2"></span>
                    {{ child.name }}
                    <span class="ima-unread-dot" *ngIf="isPlacesLink(child.url) && hasChatroomUnread" [attr.aria-label]="'layout.chat.unreadPlaceChat' | translate"></span>
                  </button>
                  <button
                    type="button"
                    class="app-link-row__pin"
                    [class.app-link-row__pin--active]="isFavoriteUrl(child.url)"
                    (click)="onToggleFavoriteClick($event, child, app.icon)"
                    [attr.aria-label]="isFavoriteUrl(child.url) ? ('layout.launcher.unpin' | translate) : ('layout.launcher.pinToSidebar' | translate)"
                    [attr.aria-pressed]="isFavoriteUrl(child.url)"
                  >
                    <svg cIcon name="cilStar" size="sm"></svg>
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="!app.children || app.children.length === 0">
                <button
                  cButton
                  color="primary"
                  variant="ghost"
                  class="btn-sm"
                  (click)="navigateToLink(app.url)"
                >
                  {{ 'layout.launcher.enterApp' | translate }}
                </button>
                <button
                  type="button"
                  class="app-link-row__pin"
                  [class.app-link-row__pin--active]="isFavoriteUrl(app.url)"
                  (click)="onToggleFavoriteClick($event, { name: app.name, url: app.url }, app.icon)"
                  [attr.aria-label]="isFavoriteUrl(app.url) ? ('layout.launcher.unpin' | translate) : ('layout.launcher.pinToSidebar' | translate)"
                  [attr.aria-pressed]="isFavoriteUrl(app.url)"
                >
                  <svg cIcon name="cilStar" size="sm"></svg>
                </button>
              </ng-container>
            </div>

          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </c-modal-body>
</c-modal>

<!-- 觸控裝置：長按對話列後的動作表（與桌機下拉選單項目一致） -->
<c-modal
  [visible]="sessionActionSheetOpen"
  (visibleChange)="onSessionActionSheetVisible($event)"
  alignment="center"
  class="session-action-sheet"
>
  <c-modal-header class="border-0 pb-0">
    <h5 class="modal-title fw-bold text-truncate w-100 mb-0" [attr.title]="sessionActionTarget?.name">
      {{ sessionActionTarget ? sessionLabel(sessionActionTarget.name) : ('layout.chat.defaultName' | translate) }}
    </h5>
  </c-modal-header>
  <c-modal-body class="pt-2 px-0 pb-3">
    <div class="d-flex flex-column gap-0" *ngIf="sessionActionTarget as t">
      <button
        type="button"
        class="btn btn-link text-start rounded-0 py-3 px-3 d-flex align-items-center gap-2 text-decoration-none border-bottom border-light session-action-sheet__btn"
        (click)="onSessionActionSheetPin(t)"
      >
        <svg cIcon name="cilPin" class="session-action-sheet__item-icon" size="sm"></svg>
        <span>{{ (teamImaginusNav.isPinned(team_code, t.id) ? 'layout.chat.unpin' : 'layout.chat.pin') | translate }}</span>
      </button>
      <button
        type="button"
        class="btn btn-link text-start rounded-0 py-3 px-3 d-flex align-items-center gap-2 text-decoration-none border-bottom border-light session-action-sheet__btn"
        (click)="onSessionActionSheetRename(t)"
      >
        <svg cIcon name="cilPencil" class="session-action-sheet__item-icon" size="sm"></svg>
        <span>{{ 'layout.chat.rename' | translate }}</span>
      </button>
      <button
        type="button"
        class="btn btn-link text-start rounded-0 py-3 px-3 d-flex align-items-center gap-2 text-decoration-none text-danger session-action-sheet__btn"
        (click)="onSessionActionSheetDelete(t)"
      >
        <svg cIcon name="cilTrash" size="sm"></svg>
        <span>{{ 'layout.chat.delete' | translate }}</span>
      </button>
    </div>
  </c-modal-body>
</c-modal>
